import styled from "@emotion/styled";

const Anchor = styled.a`
  color: inherit;
  border-bottom: 2px solid ${p => p.theme.colors.grey};
  text-style: underline;
  transition: color 0.33s var(--ease-out-quart), border 0.33s var(--ease-out-quart);
  
  &:visited {
    color: ${p => p.theme.colors.primary};
    opacity: 0.85;
  }
  
  &:hover,
  &:focus {
    color: ${p => p.theme.colors.accent} !important;
    border-bottom-color: ${p => p.theme.colors.accent};
  }
`;

export default Anchor;
